(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire130b"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire130b"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("e6kkp", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $a44164f773fc2172$export$6503ec6e8aabbaf; }, function (v) { return $a44164f773fc2172$export$6503ec6e8aabbaf = v; });
var $a44164f773fc2172$export$6503ec6e8aabbaf;
var $a44164f773fc2172$export$f7ad0328861e2f03;
"use strict";
var $a44164f773fc2172$var$mapping = new Map();
function $a44164f773fc2172$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$a44164f773fc2172$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $a44164f773fc2172$var$resolve(id) {
    var resolved = $a44164f773fc2172$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$a44164f773fc2172$export$6503ec6e8aabbaf = $a44164f773fc2172$var$register;
$a44164f773fc2172$export$f7ad0328861e2f03 = $a44164f773fc2172$var$resolve;

});

parcelRegister("aBozd", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $7b806a916686d44b$export$bdfd709ae4826697; }, function (v) { return $7b806a916686d44b$export$bdfd709ae4826697 = v; });
var $7b806a916686d44b$export$bdfd709ae4826697;
var $7b806a916686d44b$export$c9e73fbda7da57b6;
var $7b806a916686d44b$export$5a759dc7a1cfb72a;
"use strict";
var $7b806a916686d44b$var$bundleURL = {};
function $7b806a916686d44b$var$getBundleURLCached(id) {
    var value = $7b806a916686d44b$var$bundleURL[id];
    if (!value) {
        value = $7b806a916686d44b$var$getBundleURL();
        $7b806a916686d44b$var$bundleURL[id] = value;
    }
    return value;
}
function $7b806a916686d44b$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $7b806a916686d44b$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $7b806a916686d44b$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $7b806a916686d44b$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$7b806a916686d44b$export$bdfd709ae4826697 = $7b806a916686d44b$var$getBundleURLCached;
$7b806a916686d44b$export$c9e73fbda7da57b6 = $7b806a916686d44b$var$getBaseURL;
$7b806a916686d44b$export$5a759dc7a1cfb72a = $7b806a916686d44b$var$getOrigin;

});

var $490c37170dae31a0$exports = {};


(parcelRequire("e6kkp")).register((parcelRequire("aBozd")).getBundleURL("gtLjG"), JSON.parse('["gtLjG","index.472d7bbe.js","8l45c","selfoss-sw-offline.js"]'));

})();
//# sourceMappingURL=index.runtime.aca3fa3d.js.map
